module.exports = window.__loadMfRemote("refundCustomer", "refundCustomerUrl");